import React, { useCallback, useEffect, useState } from 'react'
import {
    Container,
    Header,
    ContactContainer,
    ContactTable,
    Filtros,
} from './styles'
import { FiEdit2, FiPlus, FiTrash2 } from 'react-icons/fi'
import api, { operation } from '../../services/axios'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import { cnpjCpfMask } from '../../utils/masks'
import AlertDelete from '../../components/Favorites/AlertDelete'
import SaveOrEdit from '../../components/Favorites/SaveOrEdit'
import { get } from 'lodash'
import Loading from '../../components/Loading'
import { Pagination, TextField } from '@mui/material'
const initalContact = {
    agencia: '',
    compe: '',
    email: '',
    ispb: '',
    nomeTitular: '',
    numeroConta: '',
    numeroDocumentoTitular: '',
    telefone: '',
    tipoConta: 'null',
}
const Favoritos: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const [contacts, setContacts] = useState([])
    const [contact, setContact] = useState(initalContact)
    const [isAlertDeleteOpen, setIsAlertDeleteOpen] = useState(false)
    const [isSaveOrEditOpen, setIsSaveOrEditOpen] = useState(false)
    const [idDelete, setIdDelete] = useState(0)
    const [title, setTitle] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [contactsFavsPage, setContactsFavsPage] = useState(1)
    const [contactsFavsCount, setContactsFavsCount] = useState(0)
    const [bySomething, setBySomething] = useState('')
    // const [contactSelected]
    const getContacts = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                const { data } = await api.post(
                    `/contatos/${contactsFavsPage}`,
                    {
                        cnpj_cpf,
                        bySomething,
                    }
                )
                setContacts(data.contactsFavs)
                setContactsFavsCount(data.countContactsFavs)
                setIsLoading(false)
            } catch (e: any) {
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf, contactsFavsPage, bySomething])
    useEffect(() => {
        getContacts()
    }, [getContacts])

    function handleDelete(idDelete: number) {
        setIdDelete(idDelete)
        setIsAlertDeleteOpen(true)
    }

    function handleSaveOrEdit(contact: any, title: string) {
        setTitle(title)
        setContact(contact)
        setIsSaveOrEditOpen(true)
    }

    function renderContactsRow() {
        return contacts.map((contact: any) => {
            return (
                <tr key={contact.id}>
                    <td>{contact.nomeTitular}</td>
                    <td className="">{contact.email}</td>
                    <td>{cnpjCpfMask(contact.numeroDocumentoTitular)}</td>
                    {/* <td>{contact.agencia}-{contact.numeroConta} <br /> {contact.tipoConta}</td> */}
                    <td className="actions">
                        <span onClick={() => handleDelete(contact.id)}>
                            <FiTrash2 size={20} />
                        </span>
                        <span
                            onClick={() =>
                                handleSaveOrEdit(
                                    contact,
                                    'Editar contato favorito'
                                )
                            }
                        >
                            <FiEdit2 size={20} />
                        </span>
                    </td>
                </tr>
            )
        })
    }
    return (
        <Container>
            <Header>
                <div className="title">
                    <h1>Contatos favoritos</h1>
                    <p>Crie e gerencie seus contatos favoritos</p>
                </div>
                <div className="actions">
                    <button
                        onClick={() =>
                            handleSaveOrEdit(
                                initalContact,
                                'Criar novo contato favorito'
                            )
                        }
                    >
                        <FiPlus size={20} /> Novo contato
                    </button>
                </div>
            </Header>
            <Filtros>
                <div className="input-group">
                    <div className="input-wrapper">
                        <label htmlFor="">Procurar por:</label>
                        <TextField
                            className="input"
                            name="byCpnj_cpf"
                            id="outlined-basic"
                            value={bySomething}
                            onChange={(e) => setBySomething(e.target.value)}
                            placeholder="Procure por nome, email ou CPF/CNPJ"
                            variant="outlined"
                        />
                    </div>
                </div>
            </Filtros>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <ContactContainer>
                        <ContactTable>
                            <thead>
                                <tr>
                                    <th className="order">Nome</th>
                                    <th>Email</th>
                                    <th>CPF/CNPJ</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>{renderContactsRow()}</tbody>
                        </ContactTable>
                    </ContactContainer>
                    <div className="pagination">
                        <Pagination
                            onChange={(e, value) => setContactsFavsPage(value)}
                            page={contactsFavsPage}
                            count={contactsFavsCount}
                            color="primary"
                            variant="outlined"
                            shape="rounded"
                        />
                    </div>
                </>
            )}
            <AlertDelete
                isAlertDeleteOpen={isAlertDeleteOpen}
                setIsAlertDeleteOpen={setIsAlertDeleteOpen}
                contacts={contacts}
                setContacts={setContacts}
                cnpj_cpf={cnpj_cpf}
                idDelete={idDelete}
            />
            <SaveOrEdit
                isSaveOrEditOpen={isSaveOrEditOpen}
                setIsSaveOrEditOpen={setIsSaveOrEditOpen}
                contacts={contacts}
                setContacts={setContacts}
                contact={contact}
                cnpj_cpf={cnpj_cpf}
                title={title}
            />
        </Container>
    )
}

export default Favoritos
